// extracted by mini-css-extract-plugin
module.exports = {"pointsCard":"styles_pointsCard__2G12f","points":"styles_points__1Hbm1","button":"styles_button__2lR_V"};